var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadWalletTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 72,
    viewBox: "0 0 59 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3180_78630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0657 0.59375H3.5538C2.92234 0.59375 2.31673 0.844598 1.87021 1.29111C1.4237 1.73763 1.17285 2.34323 1.17285 2.9747V69.0342C1.17285 69.6657 1.4237 70.2713 1.87021 70.7178C2.31673 71.1643 2.92234 71.4152 3.5538 71.4152H55.4467C56.0781 71.4152 56.6837 71.1643 57.1303 70.7178C57.5768 70.2713 57.8276 69.6657 57.8276 69.0342V17.1176L40.0657 0.59375Z",
    fill: "#F2F4F7",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4464 17.1176H57.8273L40.0654 0.59375V14.7366C40.0654 15.3681 40.3163 15.9737 40.7628 16.4202C41.2093 16.8667 41.8149 17.1176 42.4464 17.1176Z",
    fill: "#E4E7EC",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4941 43.0484V25.4531",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6724 32.9293L29.4224 25.4531L22.3271 32.9293",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3271 52.418H36.6724",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3180_78630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.8452,
    height: 72,
    fill: "white",
    transform: "translate(0.577148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWalletTemplateIcon);
export default __webpack_public_path__ + "684b17a5e8a66e4e0d0c0ee4c1198af5.svg";
export { ForwardRef as ReactComponent };